import { render, staticRenderFns } from "./SenderLetterPage.vue?vue&type=template&id=247211d8&scoped=true&"
import script from "./SenderLetterPage.vue?vue&type=script&lang=js&"
export * from "./SenderLetterPage.vue?vue&type=script&lang=js&"
import style0 from "./SenderLetterPage.vue?vue&type=style&index=0&id=247211d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247211d8",
  null
  
)

export default component.exports